/**
 * @file useActiveShopId.ts
 * @description Магазин активного кабинета для памяти «Последние» общих полей
 * конструктора (phase19.16, партия SB120; uiux-sb120-fields §3, §4).
 * Контекст читается мягко, без `useAuth()` (как `ShopLayout`): поля живут и
 * вне провайдера (тесты, превью) — тогда `null`, память общая, без магазина.
 */

import { useContext } from "react";

import { AuthContext } from "../../auth/AuthContext";

/** Магазин активного кабинета; платформа или нет входа — `null`. */
export function useActiveShopId(): string | null {
  const ctx = useContext(AuthContext)?.me?.activeContext ?? null;
  return ctx?.contextType === "SHOP" ? (ctx.shop?.id ?? null) : null;
}
